import React from 'react';
import './About.css';

import { Button, Heading} from '../../../components';
import { about } from '../../../constants';



const About = () => {

  const { sub, heading, description, image, button } = about;

  return (
    <section className="about">

      {/* About Image */}
      <div className="image">
        <div className="sub-image one">
          <img src={image.src1} alt={image.alt1} />
          <img src={image.src2} alt={image.alt2} />
        </div>
        <div className="sub-image two">
          <img src={image.src3} alt={image.alt3} />
          <img src={image.src4} alt={image.alt4} />
        </div>
      </div>

      {/* Introduction Content */}
      <div className="content">

        {/* Section Heading */}
        <Heading title={heading} subTitle={sub} sideHeading />

        {/* Description */}
        {description.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}

        {/* Button Component: Links to a specific page or action */}
        <Button link={button.link} title={button.text} />

      </div>
    </section>
  );
};

export default About;